import { useQuery } from "@tanstack/react-query";
import { client, type JobSchema } from "@augmodo/lebron-browser-client";

export function useFetchJob(jobId: string) {
  return useQuery({
    queryKey: ["job", jobId],
    queryFn: async () => {
      const response = await client.get({
        url: `/v1/jobs/${jobId}`,
      });

      if (response.error) {
        throw new Error(`Failed to fetch job: ${response.error}`);
      }

      return response.data as JobSchema;
    },
    enabled: !!jobId,
  });
}
